import { render, staticRenderFns } from "./addOrEditPrizes.vue?vue&type=template&id=393f5b04&scoped=true"
import script from "./addOrEditPrizes.vue?vue&type=script&lang=js"
export * from "./addOrEditPrizes.vue?vue&type=script&lang=js"
import style0 from "./addOrEditPrizes.vue?vue&type=style&index=0&id=393f5b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f5b04",
  null
  
)

export default component.exports